import React from 'react'
import Navbar from '../components/Navbar'
import Tvseries from '../components/Tvseries'

const Tvseriespage = () => {
  return (
    <>
      <Navbar/>
      <Tvseries/>
    </>
  )
}

export default Tvseriespage
